var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _c(
        "v-flex",
        {
          staticClass: "d-flex align-center",
          attrs: { xs10: "", "offset-xs1": "", "mb-3": "" },
        },
        [
          _c("v-text-field", {
            staticClass: "flex-grow-1",
            attrs: {
              "append-icon": "search",
              label: "Cerca",
              "single-line": "",
              "hide-details": "",
            },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
          _vm.orderHistoryLen
            ? _c(
                "v-btn",
                {
                  staticClass: "btn-refresh",
                  attrs: { icon: "", color: "primary" },
                  on: { click: _vm.reloadOrders },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "25",
                        height: "25",
                        fill: "none",
                        stroke: "#757575",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", { attrs: { d: "M20 19v-4h-4" } }),
                      _c("path", {
                        attrs: { d: "M4 13a8.1 8.1 0 0 0 15.5 2" },
                      }),
                      _c("path", { attrs: { d: "M4 5v4h4" } }),
                      _c("path", {
                        attrs: { d: "M20 11A8.1 8.1 0 0 0 4.5 9" },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          !_vm.orderHistoryLen
            ? _c("v-progress-circular", {
                staticClass: "circular",
                attrs: { indeterminate: "", color: "primary", size: "25" },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "v-flex",
        { attrs: { xs12: "", md10: "", "offset-md1": "" } },
        [
          _c("v-data-table", {
            staticClass: "history-table elevation-1 mb-6",
            attrs: {
              headers: _vm.headers,
              "item-key": "ID",
              items: _vm.orderHistory,
              loading: !_vm.orderHistoryLen,
              "fixed-header": true,
              search: _vm.search,
              sortBy: "ID",
              sortDesc: true,
            },
            on: {
              "click:row": (item) => {
                _vm.orderDetails = item.details
                _vm.activeOrderId = item.ID
                _vm.activeOrderState = item.row_state
                _vm.detailsDialog = true
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: `item.status`,
                  fn: function ({ item }) {
                    return [
                      _c(
                        "div",
                        { staticClass: "pt-2 pb-1" },
                        [
                          _c(
                            "v-badge",
                            { attrs: { bordered: "", overlap: "" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "badge" }, slot: "badge" },
                                [_vm._v(_vm._s(item.details.length))]
                              ),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { top: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: {
                                                      fab: "",
                                                      small: "",
                                                      color:
                                                        _vm.activeRowIconStatus(
                                                          item.row_state
                                                        ).color,
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c("v-icon", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.activeRowIconStatus(
                                                        item.row_state
                                                      ).icon
                                                    )
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "message." +
                                            _vm.activeRowIconStatus(
                                              item.row_state
                                            ).translation_source
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { scrollable: "" },
          on: { "update:returnValue": _vm.cleanData },
          model: {
            value: _vm.detailsDialog,
            callback: function ($$v) {
              _vm.detailsDialog = $$v
            },
            expression: "detailsDialog",
          },
        },
        [
          _vm.parsedItems.length == 0
            ? _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "", "justify-center": "" } },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.activeOrder
            ? _c(
                "v-card",
                {
                  staticClass: "login-window",
                  attrs: { shaped: "", elevation: "5" },
                },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "align-center bg-primary" },
                    [
                      _c(
                        "v-flex",
                        { attrs: { "d-flex": "", "flex-column": "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { "d-flex": "", "flex-row": "" } },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "ml-3 my-0 mr-0 p-0 text-subtitle-1 text-md-h6",
                                },
                                [
                                  _vm._v(
                                    " Order: #" +
                                      _vm._s(_vm.activeOrder.ID) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "ml-9 my-0 mr-0 p-0 text-subtitle-1 text-md-h6",
                                },
                                [
                                  _vm._v(
                                    " Data: " +
                                      _vm._s(
                                        _vm._f("asDate")(_vm.activeOrder.date)
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "p",
                            {
                              staticClass:
                                "ml-3 my-0 mr-0 p-0 text-subtitle-1 text-md-h6",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.Note")) +
                                  " " +
                                  _vm._s(_vm.activeOrder.Notes) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          staticStyle: { top: "5px", right: "5px" },
                          attrs: { absolute: "", icon: "", color: "white" },
                          nativeOn: {
                            click: function ($event) {
                              _vm.detailsDialog = false
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "", "justify-center": "" } },
                        _vm._l(_vm.parsedItems, function (item) {
                          return _c("item-card", {
                            key: item.id,
                            attrs: { item: item, canDelete: false },
                            on: { restore: _vm.mapAndRestore },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }